import { render, staticRenderFns } from "./BadgePreview.vue?vue&type=template&id=82eb2ce2&scoped=true"
import script from "./BadgePreview.vue?vue&type=script&lang=js"
export * from "./BadgePreview.vue?vue&type=script&lang=js"
import style0 from "./BadgePreview.vue?vue&type=style&index=0&id=82eb2ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eb2ce2",
  null
  
)

export default component.exports